import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Youtube } from "lucide-react";
import { api } from "../lib/api";

export default function Footer() {
  const [cities, setCities] = useState([]);
  const [services, setServices] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/cities"), api.get("/services")])
      .then(([c, s]) => {
        setCities(c.data);
        setServices(s.data);
      })
      .catch(() => {});
  }, []);

  return (
    <footer className="bg-brand-navy text-white mt-24" data-testid="site-footer">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-white rounded-xl p-2 flex items-center justify-center">
                <img
                  src="https://img1.wsimg.com/isteam/ip/6251f5ed-3ec2-463f-9bc9-248d796842b9/Untitled%20design%20(2)-01%20(1).png/:/rs=w:200,h:200,cg:true,m"
                  alt="The Pool Guru logo"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <div className="font-heading font-extrabold text-lg">The Pool Guru</div>
                <div className="text-xs font-semibold tracking-widest text-brand-pink uppercase">
                  Treasure Coast
                </div>
              </div>
              <img
                src="/flamingo.png"
                alt="Pool Guru flamingo mascot"
                className="w-10 h-10 object-contain ml-auto -rotate-12 drop-shadow-lg"
                data-testid="footer-mascot"
                loading="lazy"
              />
            </div>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Family-owned pool cleaning & maintenance trusted across the Treasure Coast for over 20 years.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/poolgurutc/"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-brand-pink flex items-center justify-center transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@ThePoolGuruPSL"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-brand-pink flex items-center justify-center transition-colors"
                data-testid="footer-youtube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <div className="font-heading font-bold text-sm uppercase tracking-widest text-brand-pink mb-4">
              Services
            </div>
            <ul className="space-y-2">
              {services.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-heading font-bold text-sm uppercase tracking-widest text-brand-pink mb-4">
              Service Areas
            </div>
            <ul className="space-y-2">
              {cities.slice(0, 8).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/pool-service-${c.slug}`}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/locations" className="text-sm text-brand-blue font-semibold">
                  View all →
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-heading font-bold text-sm uppercase tracking-widest text-brand-pink mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-brand-blue" />
                <a href="tel:7722890405" className="hover:text-white">772-289-0405</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-brand-blue" />
                <a href="mailto:info@thepoolgurupsl.com" className="hover:text-white break-all">
                  info@thepoolgurupsl.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-blue" />
                <span>1961 SE Crowberry Dr, Port St. Lucie, FL</span>
              </li>
            </ul>
            <Link to="/admin/login" className="inline-block mt-6 text-xs text-slate-500 hover:text-slate-300" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} The Pool Guru Treasure Coast — All Rights Reserved.</div>
          <div>Professional pool cleaning in Port St. Lucie, Fort Pierce, Stuart & beyond.</div>
        </div>
      </div>
    </footer>
  );
}
